import { create } from 'zustand';

interface PublicSidebarStateStore {
  isRTL: boolean;
  id: string;
  
  // Actions
  setIsRTL: (isRTL: boolean) => void;
  setId: (id: string) => void;
  
  // Initialize from localStorage and document
  initializeState: () => void;
}

export const usePublicSidebarStateStore = create<PublicSidebarStateStore>((set, get) => ({
  isRTL: document.documentElement.dir === "rtl",
  id: localStorage.getItem('sidebarId') || '',
  
  setIsRTL: (isRTL) => set({ isRTL }),
  setId: (id) => set({ id }),
  
  initializeState: () => {
    set({
      isRTL: document.documentElement.dir === "rtl",
      id: localStorage.getItem('sidebarId') || '',
    });
  },
}));
